import React, { useEffect, useState } from 'react';
import { Settings as SettingsIcon, CreditCard, Truck, ShieldCheck, Database, Store, Bell, Save } from 'lucide-react';
export function AdminSettings() {
  const [settings, setSettings] = useState(() => {
    const stored = localStorage.getItem('yarbo_store_settings');
    if (stored) return JSON.parse(stored);
    return {
      storeName: 'Merem Robotics',
      supportEmail: 'support@meremrobotics.com',
      supportPhone: '1-800-555-0199',
      businessAddress: 'Michigan, USA',
      allowGuestCheckout: true,
      requirePhone: false,
      yarboCareEnabled: true,
      adminNotificationEmail: 'admin@meremrobotics.com',
      adminNotificationPhone: ''
    };
  });
  const [saveMessage, setSaveMessage] = useState('');
  useEffect(() => {
    localStorage.setItem('yarbo_store_settings', JSON.stringify(settings));
  }, [settings]);
  const handleChange = (key: string, value: any) => {
    setSettings((prev: any) => ({
      ...prev,
      [key]: value
    }));
  };
  const handleSave = () => {
    localStorage.setItem('yarbo_store_settings', JSON.stringify(settings));
    setSaveMessage('Settings saved successfully');
    setTimeout(() => setSaveMessage(''), 3000);
  };
  return <div className="space-y-6 max-w-4xl" data-id="element-832">
      <div className="flex items-center justify-between" data-id="element-833">
        <h1 className="text-2xl font-extrabold text-gray-900" data-id="element-834">Settings</h1>
        <div className="flex items-center gap-3" data-id="element-835">
          {saveMessage && <span className="text-sm font-bold text-green-600" data-id="element-836">
              {saveMessage}
            </span>}
          <button onClick={handleSave} className="flex items-center gap-2 bg-yarbo-dark text-white font-bold px-4 py-2 rounded-lg hover:bg-black transition-colors" data-id="element-837">
            <Save className="w-4 h-4" data-id="element-838" /> Save Settings
          </button>
        </div>
      </div>

      <div className="bg-white border border-gray-200 rounded-xl overflow-hidden" data-id="element-839">
        {/* Store Settings */}
        <div className="p-6 border-b border-gray-200" data-id="element-840">
          <div className="flex items-center gap-3 mb-4" data-id="element-841">
            <div className="w-10 h-10 bg-gray-100 rounded-lg flex items-center justify-center" data-id="element-842">
              <Store className="w-5 h-5 text-gray-600" data-id="element-843" />
            </div>
            <div data-id="element-844">
              <h2 className="text-lg font-bold text-gray-900" data-id="element-845">Store Details</h2>
              <p className="text-sm text-gray-500" data-id="element-846">
                Basic information about your store
              </p>
            </div>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4" data-id="element-847">
            <div data-id="element-848">
              <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-849">
                Store Name
              </label>
              <input type="text" value={settings.storeName} onChange={e => handleChange('storeName', e.target.value)} className="w-full border-gray-300 rounded-lg shadow-sm focus:border-yarbo-dark focus:ring-yarbo-dark text-sm" data-id="element-850" />
            </div>
            <div data-id="element-851">
              <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-852">
                Support Email
              </label>
              <input type="email" value={settings.supportEmail} onChange={e => handleChange('supportEmail', e.target.value)} className="w-full border-gray-300 rounded-lg shadow-sm focus:border-yarbo-dark focus:ring-yarbo-dark text-sm" data-id="element-853" />
            </div>
            <div data-id="element-854">
              <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-855">
                Support Phone
              </label>
              <input type="text" value={settings.supportPhone} onChange={e => handleChange('supportPhone', e.target.value)} className="w-full border-gray-300 rounded-lg shadow-sm focus:border-yarbo-dark focus:ring-yarbo-dark text-sm" data-id="element-856" />
            </div>
            <div data-id="element-857">
              <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-858">
                Business Address
              </label>
              <input type="text" value={settings.businessAddress} onChange={e => handleChange('businessAddress', e.target.value)} className="w-full border-gray-300 rounded-lg shadow-sm focus:border-yarbo-dark focus:ring-yarbo-dark text-sm" data-id="element-859" />
            </div>
          </div>
        </div>

        {/* Checkout Settings */}
        <div className="p-6 border-b border-gray-200" data-id="element-860">
          <div className="flex items-center gap-3 mb-4" data-id="element-861">
            <div className="w-10 h-10 bg-indigo-100 rounded-lg flex items-center justify-center" data-id="element-862">
              <SettingsIcon className="w-5 h-5 text-indigo-600" data-id="element-863" />
            </div>
            <div data-id="element-864">
              <h2 className="text-lg font-bold text-gray-900" data-id="element-865">Checkout</h2>
              <p className="text-sm text-gray-500" data-id="element-866">Checkout flow preferences</p>
            </div>
          </div>
          <div className="space-y-3" data-id="element-867">
            <label className="flex items-center gap-3" data-id="element-868">
              <input type="checkbox" checked={settings.allowGuestCheckout} onChange={e => handleChange('allowGuestCheckout', e.target.checked)} className="h-4 w-4 text-yarbo-dark focus:ring-yarbo-dark border-gray-300 rounded" data-id="element-869" />
              <span className="text-sm font-medium text-gray-700" data-id="element-870">
                Allow guest checkout
              </span>
            </label>
            <label className="flex items-center gap-3" data-id="element-871">
              <input type="checkbox" checked={settings.requirePhone} onChange={e => handleChange('requirePhone', e.target.checked)} className="h-4 w-4 text-yarbo-dark focus:ring-yarbo-dark border-gray-300 rounded" data-id="element-872" />
              <span className="text-sm font-medium text-gray-700" data-id="element-873">
                Require phone number at checkout
              </span>
            </label>
          </div>
        </div>

        {/* Notifications */}
        <div className="p-6 border-b border-gray-200" data-id="element-874">
          <div className="flex items-center gap-3 mb-4" data-id="element-875">
            <div className="w-10 h-10 bg-pink-100 rounded-lg flex items-center justify-center" data-id="element-876">
              <Bell className="w-5 h-5 text-pink-600" data-id="element-877" />
            </div>
            <div data-id="element-878">
              <h2 className="text-lg font-bold text-gray-900" data-id="element-879">
                Admin Notifications
              </h2>
              <p className="text-sm text-gray-500" data-id="element-880">
                Where to send order alerts
              </p>
            </div>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4" data-id="element-881">
            <div data-id="element-882">
              <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-883">
                Admin Notification Email
              </label>
              <input type="email" value={settings.adminNotificationEmail} onChange={e => handleChange('adminNotificationEmail', e.target.value)} className="w-full border-gray-300 rounded-lg shadow-sm focus:border-yarbo-dark focus:ring-yarbo-dark text-sm" data-id="element-884" />
            </div>
            <div data-id="element-885">
              <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-886">
                Admin Notification Phone (SMS)
              </label>
              <input type="text" value={settings.adminNotificationPhone} onChange={e => handleChange('adminNotificationPhone', e.target.value)} className="w-full border-gray-300 rounded-lg shadow-sm focus:border-yarbo-dark focus:ring-yarbo-dark text-sm" data-id="element-887" />
            </div>
          </div>
        </div>

        <div className="p-6 border-b border-gray-200" data-id="element-888">
          <div className="flex items-center gap-3 mb-4" data-id="element-889">
            <div className="w-10 h-10 bg-purple-100 rounded-lg flex items-center justify-center" data-id="element-890">
              <CreditCard className="w-5 h-5 text-purple-600" data-id="element-891" />
            </div>
            <div data-id="element-892">
              <h2 className="text-lg font-bold text-gray-900" data-id="element-893">
                Payment Processing
              </h2>
              <p className="text-sm text-gray-500" data-id="element-894">
                Stripe integration settings
              </p>
            </div>
          </div>
          <div className="bg-gray-50 p-4 rounded-lg border border-gray-200" data-id="element-895">
            <div className="flex items-center justify-between" data-id="element-896">
              <span className="text-sm font-medium text-gray-700" data-id="element-897">Mode</span>
              <span className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-bold bg-amber-100 text-amber-800" data-id="element-898">
                Test Mode
              </span>
            </div>
            <p className="text-xs text-gray-500 mt-2" data-id="element-899">
              Payments are currently simulated. No real charges are processed.
            </p>
          </div>
        </div>

        <div className="p-6 border-b border-gray-200" data-id="element-900">
          <div className="flex items-center gap-3 mb-4" data-id="element-901">
            <div className="w-10 h-10 bg-blue-100 rounded-lg flex items-center justify-center" data-id="element-902">
              <Truck className="w-5 h-5 text-blue-600" data-id="element-903" />
            </div>
            <div data-id="element-904">
              <h2 className="text-lg font-bold text-gray-900" data-id="element-905">
                Shipping & Tax
              </h2>
              <p className="text-sm text-gray-500" data-id="element-906">Calculation settings</p>
            </div>
          </div>
          <div className="space-y-3" data-id="element-907">
            <div className="bg-gray-50 p-4 rounded-lg border border-gray-200 flex items-center justify-between" data-id="element-908">
              <span className="text-sm font-medium text-gray-700" data-id="element-909">
                Shipping Mode
              </span>
              <span className="text-sm text-gray-500" data-id="element-910">Test Mode</span>
            </div>
            <div className="bg-gray-50 p-4 rounded-lg border border-gray-200 flex items-center justify-between" data-id="element-911">
              <span className="text-sm font-medium text-gray-700" data-id="element-912">
                Tax Mode
              </span>
              <span className="text-sm text-gray-500" data-id="element-913">Test Mode</span>
            </div>
          </div>
        </div>

        <div className="p-6 border-b border-gray-200" data-id="element-914">
          <div className="flex items-center gap-3 mb-4" data-id="element-915">
            <div className="w-10 h-10 bg-yarbo-yellow/20 rounded-lg flex items-center justify-center" data-id="element-916">
              <ShieldCheck className="w-5 h-5 text-yarbo-dark" data-id="element-917" />
            </div>
            <div data-id="element-918">
              <h2 className="text-lg font-bold text-gray-900" data-id="element-919">YarboCare</h2>
              <p className="text-sm text-gray-500" data-id="element-920">Protection plan settings</p>
            </div>
          </div>
          <div className="space-y-3" data-id="element-921">
            <label className="flex items-center gap-3" data-id="element-922">
              <input type="checkbox" checked={settings.yarboCareEnabled} onChange={e => handleChange('yarboCareEnabled', e.target.checked)} className="h-4 w-4 text-yarbo-dark focus:ring-yarbo-dark border-gray-300 rounded" data-id="element-923" />
              <span className="text-sm font-medium text-gray-700" data-id="element-924">
                Enable YarboCare upsells
              </span>
            </label>
            <div className="bg-gray-50 p-4 rounded-lg border border-gray-200 mt-2" data-id="element-925">
              <p className="text-xs text-gray-500" data-id="element-926">
                Pricing is using placeholder values. Final integration with
                XCotton/AIG required.
              </p>
            </div>
          </div>
        </div>

        <div className="p-6" data-id="element-927">
          <div className="flex items-center gap-3 mb-4" data-id="element-928">
            <div className="w-10 h-10 bg-red-100 rounded-lg flex items-center justify-center" data-id="element-929">
              <Database className="w-5 h-5 text-red-600" data-id="element-930" />
            </div>
            <div data-id="element-931">
              <h2 className="text-lg font-bold text-gray-900" data-id="element-932">
                Data Management
              </h2>
              <p className="text-sm text-gray-500" data-id="element-933">Reset local preview data</p>
            </div>
          </div>
          <button onClick={() => {
          if (window.confirm('Are you sure you want to clear all orders, customers, products, templates, discounts, and settings from localStorage?')) {
            localStorage.clear();
            window.location.reload();
          }
        }} className="bg-red-50 text-red-600 border border-red-200 font-bold px-4 py-2 rounded-lg hover:bg-red-100 transition-colors text-sm" data-id="element-934">
            Reset Demo Data
          </button>
        </div>
      </div>
    </div>;
}